import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.css'; // We'll create this for custom styles

// --- Icons ---
const CalendarIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ width: '18px', height: '18px', marginRight: '8px', color: '#6b7280' }}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
    </svg>
);

// --- Interfaces ---
interface RangeDatePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  onChange: (dates: [Date | null, Date | null]) => void;
  id?: string; // Add optional id prop
}

// --- Styles ---
const inputBaseStyle: React.CSSProperties = {
    border: '1px solid #d1d5db', // Match the border color from other filters
    borderRadius: '6px',
    padding: '8px 12px', // Match padding
    fontSize: '14px',
    // width: '100%', // Remove fixed width, let minWidth control it
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor: '#fff',
    color: '#1f2937',
    // height: '38px', // REMOVED: Let padding define height
    minWidth: '200px', // Keep a reasonable width for dates (adjust if needed)
    transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out' // Add transition
};

// --- Custom Input Component ---
const CustomInput = React.forwardRef<HTMLDivElement, { value?: string, onClick?: () => void, id?: string }>(
  ({ value, onClick, id }, ref) => {
    // State to manage hover effect
    const [isHovered, setIsHovered] = React.useState(false);

    // Combine base style with hover style dynamically
    const currentStyle: React.CSSProperties = {
      ...inputBaseStyle,
      borderColor: isHovered ? '#adb5bd' : '#d1d5db', // Change border on hover
    };

    return (
      <div
        style={currentStyle}
        onClick={onClick}
        ref={ref}
        id={id}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <CalendarIcon />
        <span>{value || 'Select date range'}</span>
      </div>
    );
  }
);
CustomInput.displayName = 'CustomInput'; // Add display name

// --- Main Component ---
const RangeDatePicker: React.FC<RangeDatePickerProps> = ({ startDate, endDate, onChange, id }) => {
  return (
    <DatePicker
      selected={startDate} // Only the start date is technically "selected"
      onChange={onChange}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      monthsShown={2} // Show two months
      customInput={<CustomInput id={id} />}
      dateFormat="MMM dd, yyyy"
      popperPlacement="bottom-start" // Adjust placement as needed
      calendarClassName="custom-datepicker-style" // Add custom class
    />
  );
};

export default RangeDatePicker;



